<template>
    <div>
        <div class="flex flex--directionColumn flex-s--directionColumnReverse">
        </div>
        <div id="continent-worldwide-tab">
            <template>
                <ul class="flex xmoCountryList width100 flex margin-vertical-20">
                    <template v-for="(country, countryIndex) in regions.countries">
                        <li
                            :key="countryIndex"
                            class="xmoCountryList__item flex__item width20">
                            <a
                                :href="`/outlook/${ country.slug }`"
                                class="xmoCountryList__link"
                                :data-gtm="`xmoCO__countryId${ country.id }`">
                                <img
                                    :src="getCdnLink('icons/blank.gif')"
                                    :data-src="getCdnLink(`icons/flag/iso/16/${ country.isoCode }.png`)"
                                    :alt="country.name"
                                    class="xmoNavigationOverlay__listItemIcon pos-relative margin-right-5 lazy"
                                    height="16px"
                                    width="16px">
                                <span>{{ country.name }}</span>
                            </a>
                        </li>
                    </template>
                </ul>
            </template>
        </div>
    </div>
</template>

<script>
    import capitalizeMixin from 'mixins/capitalizeMixin';
    import { LazyLoader } from 'tools/lazyLoader/lazyLoader';
    import { getCdnLink } from 'tools/getCdnLink';

    export default {
        mixins: [capitalizeMixin],
        props: {
            regions: { type: Object, required: true },
            marketData: { type: Object, required: true },
        },
        data() {
            return {
                visibleRegion: 0,
                selectedRegion: null,
                currentCountries: [],
                countryFound: false,
            };
        },
        methods: {
            getCdnLink: getCdnLink,
            isContinentVisible(continent) {
                return continent.id === this.visibleRegion || this.visibleRegion === 0;
            },
            setVisibleRegion(regionId) {
                this.visibleRegion = regionId;
                this.$nextTick(() => {
                    const lazyLoad = new LazyLoader('img[data-src]');
                    lazyLoad.init();
                });
            },
        },
        mounted() {
            new LazyLoader('img[data-src]');
        },
    };
</script>
